module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/chart-3b0f7a9e03c08271a1a26c386917ed64.svg";